import { render, staticRenderFns } from "./ProductImagesUgc.vue?vue&type=template&id=423cccbc&scoped=true&"
import script from "./ProductImagesUgc.vue?vue&type=script&lang=js&"
export * from "./ProductImagesUgc.vue?vue&type=script&lang=js&"
import style0 from "./ProductImagesUgc.vue?vue&type=style&index=0&id=423cccbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423cccbc",
  null
  
)

export default component.exports